export const isInvalidEmail = (email: string | undefined) => {
  const emailRegex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/
  if (!email?.length) {
    return 'Email address is required'
  } else if (!emailRegex.test(email)) {
    return 'Please enter a valid email address'
  } else return undefined
}
